import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function LandingFooter() {
  const navigate = useNavigate();
  return (
    <>
      <section className="py-10 sm:py-14 bg-gradient-to-r from-[#4F4CB9] via-[#7A44B8] to-[#9A3DB2]" data-testid="landing-final-cta-section">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-white">Ready for a tutor who never runs out of patience?</h2>
          <p className="text-white/80 mt-3">Free for 7 days. No credit card needed. Class 5-9 CBSE Math & Science ready today.</p>
          <button
            onClick={() => navigate("/onboarding")}
            data-testid="footer-cta-button"
            className="mt-6 inline-flex items-center gap-2 bg-card text-foreground font-bold px-7 py-3.5 rounded-full hover:scale-105 active:scale-95 transition-all"
          >
            Start Learning Free <ArrowRight size={17} />
          </button>
        </div>
      </section>
      <footer className="py-10 bg-slate-950 text-slate-300 border-t border-slate-800" data-testid="landing-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <img
              src="https://customer-assets-jai6qajn.emergentagent.net/job_student-genius-26/artifacts/kbshcq5q_Branding-02.png"
              alt="SmartGuru Logo Icon"
              className="h-8 w-8 object-contain"
              data-testid="footer-logo-icon"
            />
            <div className="leading-none">
              <p className="font-heading font-bold text-sm bg-gradient-to-r from-[#B96AD1] via-[#8B88E0] to-[#F080BC] bg-clip-text text-transparent">SmartGuru.io</p>
              <p className="font-notebook text-[10px] text-slate-300">Your Smarter Way to Learn.</p>
            </div>
          </div>
          <p className="text-xs text-slate-400">© 2026 SmartGuru.io — Built for CBSE Class 5-9 students.</p>
          <Link to="/contact" data-testid="footer-contact-link" className="text-xs font-semibold text-slate-300 hover:text-white underline">Contact Us</Link>
        </div>
      </footer>
    </>
  );
}
